import React from 'react';
import { Confirm } from '../../../../../UiKit';

const ConfirmModal = ({ title, message, onConfirm, onCancel, loading }) => {
  const content = {
    text: title,
    messages: [{ text: message }],
    buttons: [
      { text: 'Cancel', action: 'cancel' },
      { text: 'Confirm', action: 'confirm', color: '#318616' },
    ],
  };

  const handleClick = (action) => {
    if (action === 'confirm') {
      onConfirm();
    } else {
      onCancel();
    }
  };

  return (
    <Confirm
      show
      content={content}
      close={onCancel}
      handleClick={handleClick}
      isDisabled={loading}
    />
  );
};

export default ConfirmModal;
